import AdminProfileContent from "../../../components/Admin/Profile"

const AdminProfile  = () => {

    return (
        <>
            <h1 className="font-doran text-center mb-4 font-medium">  اطلاعات پروفایل کاربری </h1>

            <AdminProfileContent />

        </>
    )

}

export default AdminProfile 